var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckboxgrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55556 1.5C2.4203 1.5 1.5 2.4203 1.5 3.55556V12.4444C1.5 13.5797 2.4203 14.5 3.55556 14.5H12.4444C13.5797 14.5 14.5 13.5797 14.5 12.4444V3.55556C14.5 2.4203 13.5797 1.5 12.4444 1.5H3.55556ZM3.55556 0C1.59188 0 0 1.59188 0 3.55556V12.4444C0 14.4081 1.59188 16 3.55556 16H12.4444C14.4081 16 16 14.4081 16 12.4444V3.55556C16 1.59188 14.4081 0 12.4444 0H3.55556Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxgrey);
export default __webpack_public_path__ + "static/media/checkboxgrey.da46040e.svg";
export { ForwardRef as ReactComponent };